import { toast } from "vue3-toastify";
import { IdEtiqueta, IdGrupo } from "../common-types";
import { ResponseEtiqueta } from "../etiquetas/etiquetas.service";
import { GenericServiceBase } from "../generic-service";

export type CreateGrupoEtiqueta = {
  idGrupo: IdGrupo;
  idEtiqueta: IdEtiqueta;
  idUsuario?: string;
  idInbox?: string;
};

export type ResponseGrupoEtiqueta = {
  idGrupo: IdGrupo;
  idEtiqueta: IdEtiqueta;
};

export class GrupoEtiquetaService extends GenericServiceBase {
  constructor() {
    super("grupos-etiquetas");
  }

  async create(etiqueta: CreateGrupoEtiqueta) {
    return await this.f.post("", etiqueta);
  }

  async getAllLinks() {
    return (await this.f.get("")) as ResponseGrupoEtiqueta[];
  }

  async getEtiquetasByGrupo(idGrupo: IdGrupo) {
    try {
      return (await this.f.get(`/${idGrupo}`)) as ResponseEtiqueta[];
    } catch (e) {
      console.error(e);
      toast.error(
        (e as Error).message || `Não foi possível recuperar as etiquetas.`,
      );
      return [];
    }
  }

  async getCountByEtiqueta(idEtiqueta: IdEtiqueta): Promise<number> {
    try {
      const res = (await this.f.get(`/count/${idEtiqueta}`)) as {
        count: number;
      };
      return res.count ?? 0;
    } catch {
      return 0;
    }
  }

  async remove(idGrupo: IdGrupo, idEtiqueta: IdEtiqueta) {
    return await this.f.delete(`/${idGrupo}/${idEtiqueta}`);
  }
}
